import { toast } from 'sonner';
import SitemapGenerator from '@/utils/sitemapGenerator';

export const useSitemapAutoUpdate = () => {
    const updateSitemapAndPing = async (articleInfo = null) => {
        try {
            console.log('🔄 Auto-updating sitemap after article operation...');
            
            const generator = new SitemapGenerator();
            const sitemap = await generator.updateSitemap();
            
            if (sitemap) {
                // Отправляем пинги поисковым системам
                const results = await generator.pingSearchEngines();
                
                const successful = results.filter(r => r.status === 'fulfilled' && r.value).length;
                const total = results.length;
                
                if (successful > 0) {
                    if (articleInfo) {
                        toast.success(`Статья "${articleInfo.title}" добавлена в sitemap и отправлена в ${successful}/${total} поисковых систем`);
                    } else {
                        toast.success(`Sitemap обновлен и отправлен в ${successful}/${total} поисковых систем`);
                    }
                    console.log('✅ Sitemap updated and search engines notified successfully');
                } else {
                    toast.warning('Sitemap обновлен, но возникли проблемы с отправкой в поисковые системы');
                    console.warn('⚠️ Sitemap updated but search engine notification failed');
                }
                
                return true;
            }
        } catch (error) {
            console.error('❌ Error auto-updating sitemap:', error);
            toast.error('Ошибка автоматического обновления sitemap');
            return false;
        }
    };

    const updateSitemapOnly = async () => {
        try {
            console.log('🔄 Updating sitemap only...');
            const generator = new SitemapGenerator();
            const sitemap = await generator.updateSitemap();
            
            if (sitemap) {
                toast.success('Sitemap успешно обновлен');
                console.log('✅ Sitemap updated successfully');
                return true;
            }
        } catch (error) {
            console.error('❌ Error updating sitemap:', error);
            toast.error('Ошибка обновления sitemap');
            return false;
        }
    };

    return { 
        updateSitemapAndPing, 
        updateSitemapOnly 
    };
};
